import React from 'react';
import {
  IconGlobal,
} from '@americanexpress/dls-icons';
import { Link } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useReactlytics } from '@americanexpress/reactlytics';
import { BASE_UI_URL } from '@americanexpress/arcade-core';

import styles from './styles/navBar.scss';
import StampsIcon from './StampsIcon';
import WishlistIcon from './WishlistIcon';
import MoreIcon from './MoreIcon';

const NavBar = ({
  pathname,
}) => {
  const intl = useIntl();
  const { track } = useReactlytics();

  const onNavClick = (navName) => {
    track({
      event: {
        identifier: 'axp-passport-tray-buttons',
        element: navName,
        type: 'click',
      },
    });
  };

  return (
    <div
      className={`${styles.navBar}`}
      data-testid="navbar"
    >
      <Link
        to={`${BASE_UI_URL}/stamps`}
        className={`${styles.navItem} ${pathname.includes('stamps') ? styles.selectedTab : null}`}
        onClick={() => onNavClick('homepage')}
        aria-current={pathname.includes('stamps') ? 'page' : undefined}
      >
        <StampsIcon isSelected={pathname.includes('stamps')} />
        <span className={`${styles.navName} arcade-label-1 ${pathname.includes('stamps') ? 'dls-bright-blue' : ''}`}>
          {intl.formatMessage({ id: 'navbar.stamp', defaultMessage: 'Stamps' })}
        </span>
      </Link>

      <Link
        to={`${BASE_UI_URL}/explore`}
        className={`${styles.navItem} ${pathname.includes('explore') ? styles.selectedTab : null}`}
        onClick={() => onNavClick('explore')}
        aria-current={pathname.includes('explore') ? 'page' : undefined}
      >
        {pathname.includes('explore') ? (
          <IconGlobal
            title="explore icon"
            titleId="explore-icon"
            className="dls-bright-blue"
            filled={true}
          />
        ) : (
          <IconGlobal title="explore icon" titleId="explore-icon" className="dls-deep-blue" />
        )}
        <span className={`${styles.navName} arcade-label-1 ${pathname.includes('explore') ? 'dls-bright-blue' : ''}`}>
          {intl.formatMessage({ id: 'navbar.explore', defaultMessage: 'Explore' })}
        </span>
      </Link>

      <Link
        to={`${BASE_UI_URL}/wishlist`}
        className={`${styles.navItem} ${pathname.includes('wishlist') ? styles.selectedTab : null}`}
        onClick={() => onNavClick('wishlist')}
        aria-current={pathname.includes('wishlist') ? 'page' : undefined}
      >
        <WishlistIcon isSelected={pathname.includes('wishlist')} />
        <span className={`${styles.navName} arcade-label-1 ${pathname.includes('wishlist') ? 'dls-bright-blue' : ''}`}>
          {intl.formatMessage({ id: 'navbar.wishList', defaultMessage: 'Wishlist' })}
        </span>
      </Link>

      <Link
        to={`${BASE_UI_URL}/more`}
        className={`${styles.navItem} ${pathname.includes('more') ? styles.selectedTab : null}`}
        onClick={() => onNavClick('more')}
        aria-current={pathname.includes('more') ? 'page' : undefined}
      >
        <MoreIcon isSelected={pathname.includes('more')} />
        <span className={`${styles.navName} arcade-label-1 ${pathname.includes('more') ? 'dls-bright-blue' : ''}`}>
          {intl.formatMessage({ id: 'navbar.more', defaultMessage: 'More' })}
        </span>
      </Link>
    </div>
  );
};

NavBar.propTypes = {
  pathname: PropTypes.string,
};

export default NavBar;
